function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Editor } from '@deephaven/console';
import { CopyButton, Icon, Modal, ModalBody, ModalHeader, ToggleButton, Tooltip } from '@deephaven/components';
import { vsJson, vsListOrdered } from '@deephaven/icons';
import "./IrisGridCellOverflowModal.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function IrisGridCellOverflowModal(_ref) {
  var _editorRef$current$ge, _editorRef$current2;
  var text = _ref.text,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setIsOpened = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showLineNumbers = _useState6[0],
    setShowLineNumbers = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormatted = _useState8[0],
    setIsFormatted = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    canFormat = _useState0[0],
    setCanFormat = _useState0[1];
  var editorRef = useRef();

  // Update format button on open
  useEffect(function enableFormatButtonWhenOpen() {
    if (!isOpen) {
      return;
    }
    try {
      JSON.parse(text);
      setCanFormat(true);
    } catch (_unused) {
      setCanFormat(false);
    }
    setIsFormatted(false);
  }, [isOpen, text]);

  // Re-layout editor on height change
  useEffect(function updateLayoutOnHeightChange() {
    if (editorRef.current) {
      editorRef.current.layout();
    }
  }, [height]);

  // Update editor options on line number toggle
  useEffect(function toggleShowLineNumber() {
    if (editorRef.current) {
      editorRef.current.updateOptions({
        lineNumbers: showLineNumbers ? 'on' : 'off'
      });
    }
  }, [showLineNumbers]);
  function toggleLineNumbers() {
    setShowLineNumbers(!showLineNumbers);
  }
  function formatAsJSON() {
    var _editorRef$current;
    var model = (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.getModel();
    if (!canFormat || !model) {
      return;
    }
    if (!isFormatted) {
      model.setValue(JSON.stringify(JSON.parse(text), undefined, 2));
      setIsFormatted(true);
    } else {
      model.setValue(text);
      setIsFormatted(false);
    }
    autoSetLineNumbers();
  }
  function autoSetLineNumbers() {
    var _editor$getModel$getL, _editor$getModel;
    var editor = editorRef.current;
    if (!editor) {
      return;
    }
    setShowLineNumbers(((_editor$getModel$getL = (_editor$getModel = editor.getModel()) === null || _editor$getModel === void 0 ? void 0 : _editor$getModel.getLineCount()) !== null && _editor$getModel$getL !== void 0 ? _editor$getModel$getL : 0) > 1);
  }
  function handleToggle() {
    if (isOpened) {
      editorRef.current = undefined;
      onClose();
    }
  }
  function onEditorInitialized(editor) {
    var _document$activeEleme;
    editorRef.current = editor;
    setHeight(editor.getContentHeight());
    editor.onDidContentSizeChange(_ref2 => {
      var contentHeight = _ref2.contentHeight;
      return setHeight(contentHeight);
    });
    autoSetLineNumbers();
    (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || _document$activeEleme.blur();
  }
  if (!isOpen && !isOpened) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    centered: true,
    keyboard: true,
    toggle: handleToggle,
    onOpened: () => setIsOpened(true),
    onClosed: () => {
      setIsOpened(false);
      setHeight(0);
    },
    className: "cell-overflow-modal",
    size: "xl",
    children: [/*#__PURE__*/_jsxs(ModalHeader, {
      toggle: onClose,
      children: [/*#__PURE__*/_jsx("h5", {
        className: "overflow-modal-title",
        children: "Cell Contents"
      }), /*#__PURE__*/_jsx(CopyButton, {
        tooltip: "Copy cell contents",
        copy: (_editorRef$current$ge = (_editorRef$current2 = editorRef.current) === null || _editorRef$current2 === void 0 ? void 0 : _editorRef$current2.getValue()) !== null && _editorRef$current$ge !== void 0 ? _editorRef$current$ge : text
      }), /*#__PURE__*/_jsxs(ToggleButton, {
        isSelected: showLineNumbers,
        "aria-label": "Toggle line numbers",
        onChange: toggleLineNumbers,
        children: [/*#__PURE__*/_jsx(Icon, {
          UNSAFE_className: "action-button-icon-with-tooltip",
          children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsListOrdered
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          children: "Toggle line numbers"
        })]
      }), canFormat && /*#__PURE__*/_jsxs(ToggleButton, {
        isSelected: isFormatted,
        "aria-label": "Format as JSON",
        onChange: formatAsJSON,
        children: [/*#__PURE__*/_jsx(Icon, {
          UNSAFE_className: "action-button-icon-with-tooltip",
          children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsJson
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          children: "Format as JSON"
        })]
      })]
    }), /*#__PURE__*/_jsx(ModalBody, {
      style: {
        height
      },
      children: /*#__PURE__*/_jsx(Editor, {
        onEditorInitialized: onEditorInitialized,
        settings: {
          value: text,
          readOnly: true,
          wordWrap: 'on',
          // Loading json language w/o the monaco workers causes UI freezes and monaco errors. TS colorizes the same
          language: canFormat ? 'typescript' : 'plaintext',
          folding: canFormat,
          padding: {
            bottom: 16
          },
          lineNumbers: showLineNumbers ? 'on' : 'off',
          overviewRulerLanes: 0,
          renderLineHighlight: 'none',
          /*
            The entire string may be 1 giant line
            Monaco by default seeds find w/ that line
            On very long strings this hangs the browser, so never seed the search
          */
          find: {
            seedSearchStringFromSelection: 'never'
          }
        }
      })
    })]
  });
}
//# sourceMappingURL=IrisGridCellOverflowModal.js.map